
import Vue from "vue";
import { PaymentService } from "@/services/payment-service";
import { Mandat } from "@/models/payment/mandat";
import { Plan } from "../../utils/payments/plan";
import { AuthService } from "@/services/auth-service";
import AppPaymentMethodItem from "./PaymentMethodItem.vue";
import AppAddPaymentMethodButton from "./AddPaymentMethodButton.vue";

export default Vue.extend({
	data() {
		return {
			mandates: null as Mandat[] | null,
			loadingMandates: true,
		};
	},
	props: {
		limitMethods: Boolean,
		plan: {
			type: Object as () => Plan
		}
	},
	computed: {
		activeMandates(): Mandat[] {
			if (!this.mandates) {
				return [];
			}
			return this.mandates.filter(c => c.status == "valid");
		},
		isDemo():boolean{
			return AuthService.wfCompany.IsDemo;
		},
		showAddButton():boolean {
			if (this.isDemo) {
				return false;
			}
			if (!this.limitMethods) {
				return true;
			}
			return this.activeMandates.length==0;
		}
	},
	methods: {
		async getMandates() {
			try {
				this.mandates = await PaymentService.getMandates();
				this.$emit("mandatesLoaded", this.activeMandates);
			} catch (err) {

			}
			this.loadingMandates = false;
		},
	},
	async created() {
		await this.getMandates();
	},
	components: {
		AppAddPaymentMethodButton,
		AppPaymentMethodItem
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
